import React, { useState } from 'react'
import { Box, Button, Card, Grid, Typography } from "@mui/material";
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import Breadcrumbs from "../../../components/breadcrumbs";
import CreationDialog from '../../../components/dialog';
import CafeteriaTable from '../../../components/admin/portalDesign/cafeteria';
import CafeteriaCreation from '../../../components/admin/portalDesign/cafeteria/cafeteriaCreation';

const Cafeteria = () => {

    const [open, setOpen] = useState(false)

    return (
        <>
            <Box p='30px'>
                <Breadcrumbs content={["Portal Design", "Cafeteria"]} />
                <Box p='15px 0'>
                    <Typography variant='t24_700' > Cafeteria </Typography>
                </Box>

                <Card style={{ boxShadow: (theme) => `0px 12px 23px ${theme.palette.grey[200]}` }}>
                    <Grid container spacing={3} sx={{ padding: '30px', pb: '20px' }} >
                        <Grid item lg={6} xs={6} sx={{ justifyContent: 'left' }}>
                            <div>
                                <Typography variant='t20_600'>Cafeteria</Typography>
                            </div>
                        </Grid>
                        <Grid item xs={6} sx={{ justifyContent: 'right', display: 'flex' }}>
                            <Button variant='contained' endIcon={<DoubleArrowIcon />} sx={{ width: '197px', height: '50px' }} onClick={() => setOpen(true)} >
                                <Typography variant='t16_500' >
                                    Add Cafeteria
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <CafeteriaTable />
                        </Grid>
                    </Grid>
                </Card>
            </Box>

            <CreationDialog open={open} setOpen={setOpen} >
                <CafeteriaCreation setOpen={setOpen} />
            </CreationDialog >
        </>
    )
}

export default Cafeteria;
